import Swal from "sweetalert2";

(function ($) {
	"use strict";

	$(".btn_generate_ticket").click(function () {
		Swal.fire({
			title: "Aguarde!",
			html: "Gerando o boleto, você será redirecionado ! ",
			onOpen: function onOpen() {
				Swal.showLoading();
			},
			allowOutsideClick: false,
		});
	});

	$(document.body).on("checkout_error", function () {
		Swal.close();
	});
})(jQuery);
